import { callApi } from './common'

function list(accountId, userSeq) {
  return callApi(`billing/alarm/${accountId}/${userSeq}`)
}

function get(accountId, userSeq, seq) {
  return callApi(`billing/alarm/${accountId}/${userSeq}/${seq}`)
}

function add(accountId, item) {
  return callApi(`billing/alarm/${accountId}`, item, 'post')
}

function modify(accountId, item) {
  return callApi(`billing/alarm/${accountId}/${item.seq}`, item, 'put')
}

function remove(accountId, seq) {
  return callApi(`billing/alarm/${accountId}/${seq}`, {}, 'delete')
}

function projects(accountId) {
  return callApi(`billing/alarm/${accountId}/projects`)
}

export default {
  list,
  add,
  modify,
  get,
  remove,
  projects,
}
